import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const venafi = defineConnector({
  identifier: "venafi",
  name: "Venafi",
  tagLine: "Machine identity management",
  logo,
  protocol: "http",
  tags: ["security"],
  auth: (app) =>
    headerAuth([{ name: "tppl-api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create a Venafi API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Venafi Control Plane, create an API key or access token and use it as a bearer token for API requests.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.venafi.cloud/v1/useraccounts",
  },
  defaultUrlPattern: () => "https://api\\.venafi\\.cloud/.*",
});
